<template>
  <sn-text-field
    :data-cy="dataCy"
    v-bind="attributes"
    v-on="listeners"
  />
</template>

<script>
import snTextField from '~/components/snui/v2/snTextField/snTextField'
import { cypressMixin } from '../mixins/cypressMixin'

export default {
  name: 'SnCurrency',
  components: { snTextField },
  mixins: [cypressMixin],
  props: {
    value: { type: [String, Number], required: false, default: '' },
    centsDisabled: { type: [Boolean], required: false, default: false },
    dataCy: { type: String, required: false, default: null }
  },
  data () {
    return {
      floatValue: this.convertToFloat(this.value),
      isActive: false
    }
  },
  computed: {
    attributes () {
      return {
        ...this.$attrs,
        value: this.displayValue,
        prefix: '$'
      }
    },
    listeners () {
      return {
        ...this.$listeners,
        input: this.onInput,
        blur: this.onBlur,
        focus: this.onFocus,
        beforeinput: this.onBeforeInput
      }
    },
    displayValue () {
      if (typeof this.floatValue !== 'number') {
        if (this.isActive) {
          return this.$el?.querySelector('input')?.value || ''
        } else {
          return ''
        }
      } else if (this.isActive) {
        return this.floatValue.toLocaleString('fullwide', { useGrouping: false })
      } else if (this.centsDisabled) {
        return this.floatValue.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 0 })
      } else {
        return this.floatValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    }
  },
  watch: {
    value (val) {
      this.floatValue = this.convertToFloat(val)
    }
  },
  mounted () {
    // In case the floatValue is different than the value prop (e.g. because the value prop had more than 2 precision points, or it was a string), then we emit the input event for the updated floatValue
    this.onInput(this.floatValue)
  },
  methods: {
    convertToFloat (val) {
      if (!val || val.length === 0) return val

      var floatVal
      if (typeof val === 'number') {
        floatVal = val
      } else {
        floatVal = parseFloat(val.toString())
      }
      if (isNaN(floatVal)) {
        return null
      } else {
        return Math.round(floatVal * 100) / 100
      }
    },
    onBeforeInput (event) {
      var { value, selectionStart, selectionEnd } = event.target

      // `event.data` here will only be set if new text is being added. Otherwise, it will be empty/null (e.g. the user hit backspace or such as...)
      if (!event.data || event.data.length === 0) return

      // Figure out what the expected value is going to be before the `input` even is triggered...
      var expectedValue = value.substring(0, selectionStart) + event.data + value.substring(selectionEnd)
      // ... and if it isn't a valid currency text, then prevent `input` event from being triggered
      var regex = /^-?(([1-9]\d*)|0)?(\.\d{0,2}$)?$/
      if (this.centsDisabled) {
        regex = /^[0-9]*$/
      }
      if (!regex.test(expectedValue)) {
        event.preventDefault()
      }
    },
    onInput (inputValue) {
      this.floatValue = this.convertToFloat(inputValue)
      this.$emit('input', this.floatValue)
    },
    onFocus (event) {
      this.isActive = true
      this.$emit('focus', event)
    },
    onBlur (event) {
      this.isActive = false
      this.$emit('blur', event)
    }
  }
}
</script>
